
import XHeader from 'vux/src/components/x-header/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { LANG } from '@/constants/lang'

export default {
data () {
return {
order_no: '',
amount: '0.00',
symbol: '¥',
account: '',
surname: '',
name: '',
payment_flow: '',
totalTime: 0,
clockHandle: null,
languages: [
{ key: 'cn', value: 'zh_CN' },
{ key: 'tw', value: 'zh_TW' },
{ key: 'en', value: 'EN' },
{ key: 'vn', value: 'VN' }
],
selectoption: '',
proofFile: null,
previewUrl: '',
uploading: false
}
},
computed: {
countdownMin () {
return String(Math.floor(this.totalTime / 60)).padStart(2, '0')
},
countdownSec () {
return String(this.totalTime % 60).padStart(2, '0')
}
},
mounted () {
this.order_no = this.$route.query.order_no
this.$models.Deposit.order({ order_no: this.order_no })
.then(response => {
if (response.data.success && response.data.data.ttl > 0) {
const data = response.data.data
this.amount = data.amount
this.symbol = data.symbol || '¥'
this.account = data.account || ''
this.surname = data.surname || ''
this.name = data.name || ''
this.payment_flow = '首页-转账-转到支付宝-输入页面上提供的支付宝账户-输入页面上提供的支付宝姓氏首字<br />如系统仅提供数字账号，转账时请勿选择带有邮箱账号之收款户'
this.totalTime = data.ttl || 0
this.startCountdown()
} else {
this.$router.replace({
path: '/error',
query: {
title: response.data.message || 'The order is expired',
description1: ''
}
})
}
})
this.setLocale()
},
beforeDestroy () {
if (this.clockHandle) {
window.clearInterval(this.clockHandle)
}
},
components: {
XHeader,
ViewBox,
PopupRadio
},
methods: {
startCountdown () {
this.clockHandle = window.setInterval(() => {
if (this.totalTime > 0) {
this.totalTime--
} else {
window.clearInterval(this.clockHandle)
}
}, 1000)
},
copyText (text) {
navigator.clipboard.writeText(text || '').then(() => {
this.$vux.toast.show({ text: this.$t('copied'), type: 'success', time: 1000 })
})
},
setLocale () {
this.$models.Deposit.ip().then(({ data }) => {
const lang = LANG[data.data.locale_id]
this.selectoption = lang

if (!localStorage.getItem('lang')) {
localStorage.setItem('lang', lang)
this.$i18n.locale = lang
}

this.resetLangList()
})
},
switchLang () {
const lang = this.selectoption
this.$i18n.locale = lang
localStorage.setItem('lang', lang)
this.resetLangList()
},
resetLangList () {
this.languages = [
{ key: 'cn', value: this.$t('cn') },
{ key: 'tw', value: this.$t('tw') },
{ key: 'en', value: this.$t('en') },
{ key: 'vn', value: this.$t('vn') }
]
},
triggerFilePicker () {
if (!this.proofFile) {
this.$refs.fileInput.click()
}
},
onFileChange (e) {
const file = e.target.files[0]
if (!file) return
this.proofFile = file
this.previewUrl = URL.createObjectURL(file)

e.target.value = ''
},
submitProof () {
if (!this.proofFile || this.uploading) return
this.uploading = true

const formData = new FormData()
formData.append('order_no', this.order_no)
formData.append('image', this.proofFile)

this.$models.Deposit.uploadProof(formData)
.then(response => {
if (response.data.success) {
this.$router.replace({ path: '/finished' })
} else {
this.$vux.toast.show({ text: response.data.message, type: 'warn', time: 2000 })
this.uploading = false
}
})
.catch(() => {
this.$vux.toast.show({ text: this.$t('uploadFailed'), type: 'warn', time: 2000 })
this.uploading = false
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Order.vue